// src/index.js
import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import { FileProvider } from './ContextAPI/FileContext';
import { DownloadsProvider } from './contexts/DownloadsContext';
import '@fortawesome/fontawesome-free/css/all.min.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';

// Suppress ResizeObserver loop error - harmless browser quirk when layout changes rapidly (e.g. closing modals)
// See: https://stackoverflow.com/questions/49384120/resizeobserver-loop-limit-exceeded
window.addEventListener('error', (e) => {
  if (e.message?.includes('ResizeObserver loop')) {
    e.stopImmediatePropagation();
    return true;
  }
}, true);

ReactDOM.render(
  <FileProvider>
    <DownloadsProvider>
      <App />
    </DownloadsProvider>
  </FileProvider>,
  document.getElementById('root')
);
